import { showDeleteConfirmation } from '@modules/common';
import { map, switchMap } from 'rxjs/operators';
import { BaseBloc } from '@core/utils/bloc';
import { Repository } from '@core/utils/repository';
import { handleMessage, requestMessage } from '@business/messages';
import { POStatusAPI } from '@business/api/poStatus';
import { POStatusResponse, POStatusID } from '@business/entities/poStatus';
import { StatusFormData } from '@modules/settings/SettingsPage/Components/TimeMaterialsTab/Tabs/POTab/ManagePO/ManagePOModal';

export class PoStatusBloc extends BaseBloc {
  private readonly statusRepo = new Repository<POStatusResponse>({
    getItemId: status => status.id,
  });

  readonly statuses$ = this.statusRepo.items$;
  readonly selectStatus = this.statusRepo.selectItem;

  onInit() {
    this.fetchStatuses().subscribe();
  }

  onReset() {
    this.statusRepo.reset();
  }

  fetchStatuses = () => {
    return POStatusAPI.fetchStatuses().pipe(this.statusRepo.ops.reset(), handleMessage({ error: requestMessage('fetch_brands_error') }));
  };

  createStatus = (data: Partial<POStatusResponse>) => {
    return POStatusAPI.createStatus(data).pipe(
      this.statusRepo.ops.addOne(item => item),
      handleMessage({
        type: requestMessage('create_brand'),
      }),
    );
  };

  fetchStatus = (id: POStatusID) => {
    return POStatusAPI.fetchStatus(id).pipe(
      this.statusRepo.ops.upsertOne(item => ({ item })),
      handleMessage({ error: requestMessage('fetch_brands_error') }),
    );
  };

  updateStatus = (id: POStatusID, data: Partial<POStatusResponse>) => {
    return POStatusAPI.updateStatus(id, data).pipe(
      this.statusRepo.ops.upsertMany(item => ({ item })),
      handleMessage({
        type: requestMessage('update_brand'),
      }),
    );
  };

  deleteStatus = (id: POStatusID) => {
    return showDeleteConfirmation('Delete Status', `Do you really want to remove this status ?`).pipe(
      switchMap(() => POStatusAPI.deleteStatus(id)),
      this.statusRepo.ops.removeOne(() => id),
      handleMessage({
        type: requestMessage('delete_brand'),
      }),
    );
  };

  createOrUpdatePOStatus = (data: StatusFormData) => {
    return POStatusAPI.createOrUpdatePOStatus(data).pipe(
      this.statusRepo.ops.reset(),
      handleMessage({
        type: requestMessage('po_status_updated'),
      }),
    );
  };
}
